import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Outlet as g, useMatch as L, Link as C } from "react-router";
import { cn as s, buttonVariants as b, CardHeader as N, CardTitle as y } from "@cold-ambulance/shadcn";
import { forwardRef as u, createElement as a } from "react";
function m({
  className: t,
  ...r
}) {
  const c = (/* @__PURE__ */ new Date()).getFullYear();
  return /* @__PURE__ */ n("p", { className: s("w-full border-t py-4 text-center", t), ...r, children: [
    "© ",
    c,
    " MedHub - Al Takassusi General Limited Company . All rights reserved"
  ] });
}
function p(t) {
  return /* @__PURE__ */ e("svg", { viewBox: "225 460 630 160", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ n("g", { children: [
    /* @__PURE__ */ n("g", { children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#00A995",
          d: `M725.6,567.7c0,11-9.4,19-19.3,19c-11,0-19.3-8.1-19.3-19v-45h-20v45c0,20.3,14.6,38,40.1,38.5
			c26.6-0.5,38.5-18.2,38.5-38.5v-45h-20V567.7z`
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#00A995",
          d: `M802.3,520.4c-5.8,0-11.2,1-16.2,2.9c0.8,2.1,5.4,13.3,6.7,16.4c2.9-1.1,6.2-1.8,9.6-1.8
			c14.3,0,23.9,12.8,23.9,25.2c0,12.5-10.1,25.2-23.9,25.2c-13.6,0-23.9-10.2-23.9-25.2v-72.8h-19.8v72.8
			c0,23.9,19.5,42.9,43.7,42.9c23.9,0,43.9-18.8,43.9-42.9C846.1,540.1,827.5,520.4,802.3,520.4z`
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#00A995",
          d: `M617.9,520.4c-8.6,0-16.1,2.9-22.6,8.8v-28.7c0.8-5.9,1-13.2-1.6-17.4c-2.7-4.3-7.8-5.6-12.6-6.1
			c0.1-2.4-1.4-2.5-3.3-2.8c-0.9-0.1-3.1-0.5-3.9-0.3c-1,0.3-1.5,1.1-1.6,2.1c-0.1,1.2-0.2,3.1-0.1,4.3c0.1,1.1,0.6,2.2,1.8,2.3
			c0.9,0.1,4.6,0.1,5.4-0.1c0.3-0.1,0.8-0.5,1-0.8c0.2-0.4,0.3-1.3,0.6-1.4c3.5,0.6,7.4,1.3,9.3,4.6c0.8,1.3,1.2,3.1,1.4,5.1
			c0.5,5.3-0.7,12-1.6,15.9c-1.7,7.8-4.3,15.3-7.2,22.6l-3.7,8.1c-1.2,2.5-2.5,4.6-4.1,6.2v3.9v57.1h20v-45c0-10.7,8.3-19,19.3-19
			c11.2,0,19.3,9.1,19.3,19v45h20v-45C653.9,537.8,639.5,520.4,617.9,520.4z`
        }
      )
    ] }),
    /* @__PURE__ */ n("g", { children: [
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#003E65",
          d: `M332.6,520.4c-13,0.5-22.7,4.5-29.7,11.5c-6.3-7-15.6-11-29.1-11.5c-25.5,0.5-40.1,17.9-40.1,38.5v45h20v-45
			c0-10.7,8.3-19,19.3-19c9.9,0,19.3,7.8,19.3,19v45h20v-45c0-10.7,8.3-19,19.3-19c9.9,0,19.3,7.8,19.3,19v45h20v-45
			C370.9,538.3,359.2,520.9,332.6,520.4z`
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#003E65",
          d: `M437.1,522.2c-0.5-0.2-1.1-0.3-1.6-0.5l-1.6-0.3c-2.9-0.7-6-1-9.4-1c-24.2,0-43.7,19-43.7,42.9
			c0,23.2,19,42.7,43.7,42.7c12.3,0,23.1-4.5,30.7-11.7c-4.4-4.7-10.2-11-13.6-14.8c-4.7,4.7-10.4,7-17.1,7
			c-12.8,0-23.9-10.2-23.9-23.2c0-12.8,10.7-23.4,23.9-23.4c10.9,0,18.7,6.7,21.8,13.6c-1.5,0-2.8-0.2-4.2-0.2
			c-6.8,0-15.1,0.8-24.2,3.4v19c7.6-3.4,15.8-5.2,24.4-5.2c8.6,0,16.7,1.8,24,5.4c1-2.9,1.6-6,1.9-9.3c0-1.1,0.2-2.3,0.2-3.4
			C468.3,543.8,455.1,527.4,437.1,522.2z`
        }
      ),
      /* @__PURE__ */ e("circle", { fill: "#003E65", cx: "519.4", cy: "562.1", r: "8.7" }),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#003E65",
          d: `M564.6,475.2c-0.3-0.8-0.9-1.3-1.7-1.4c-0.9-0.1-5.4,0.5-6,1c-0.8,0.5-0.8,1.3-0.8,2.2
			c-4.1,0.5-8.1,1.5-10.9,4.7c-3.5,4.1-3.4,10.9-2.8,16.5V563c0,10.5-5,18.7-12.8,22.6c2.9,5.1,7,10.9,11.7,14.1
			c12.7-7.5,21-21,21-36.7v-16v-4.8c-0.4-0.4-0.8-0.9-1.3-1.4c-1.7-1.9-3-4.1-4.1-6.5l-2-4.2c-0.5-1-0.9-1.9-1.2-2.9
			c-3.2-8.8-5.8-18-7.1-27.2c-0.4-3.1-0.9-6.6-0.5-9.8c0.4-4,2.1-7.6,6.7-9c0.6-0.2,2.9-0.8,3.4-0.7c0.4,0.1,0.4,0.9,0.6,1.4
			c0.2,0.3,0.7,0.7,1,0.7c0.7,0.1,3,0.1,3.8,0.1c1.4,0,3,0,3.2-1.8C565,479.9,564.9,476.1,564.6,475.2z`
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#003E65",
          d: `M525.9,593.8c-1.4-2.1-2.6-4.2-3.6-6c-1.2,0.2-2.5,0.3-3.8,0.3c-13.6,0-23.7-12.7-23.7-25.2
			c0-12.3,9.7-25.2,23.7-25.2c3.4,0,6.7,0.6,9.7,1.8c1.3-3.1,5.8-14.3,6.7-16.4c-5-1.9-10.6-2.9-16.4-2.9
			c-24.9,0-43.7,19.7-43.7,42.7c0,24,19.8,42.9,43.7,42.9c5.4,0,10.5-0.9,15.3-2.6C531,600.8,528.4,597.7,525.9,593.8z`
        }
      )
    ] })
  ] }) });
}
function M({ items: t }) {
  return /* @__PURE__ */ n("div", { className: "bg-primary mt-auto flex h-full w-36 flex-col items-center rounded-lg pt-12 text-sm", children: [
    /* @__PURE__ */ e(p, { className: "mb-11 h-24 w-24 **:fill-white" }),
    /* @__PURE__ */ e("div", { className: "w-full space-y-4 px-1", children: t.map((r) => /* @__PURE__ */ n(j, { to: r.href, children: [
      r.icon,
      /* @__PURE__ */ e("span", { children: r.label })
    ] }, r.href)) })
  ] });
}
function j({ to: t, children: r }) {
  const c = L(t);
  return /* @__PURE__ */ e(
    C,
    {
      to: t,
      className: b({
        variant: "ghost",
        className: s(
          "text-primary-foreground hover:text-primary-foreground flex h-auto w-full flex-col items-center py-4 hover:bg-black/20",
          c ? "bg-black/20" : ""
        )
      }),
      children: r
    }
  );
}
function O({
  children: t,
  items: r
}) {
  return /* @__PURE__ */ e("div", { className: "flex h-full min-h-0 flex-col md:p-4 md:pb-4", children: /* @__PURE__ */ n("div", { className: "flex h-full min-h-0 flex-1 flex-col", children: [
    /* @__PURE__ */ n("div", { className: "flex h-full min-h-0 w-full", children: [
      /* @__PURE__ */ e(M, { items: r }),
      /* @__PURE__ */ n("div", { className: "mx-8 flex min-h-0 w-full flex-1 flex-col gap-4", children: [
        t,
        /* @__PURE__ */ e(g, {})
      ] })
    ] }),
    /* @__PURE__ */ e(m, { className: "mt-8 pb-0" })
  ] }) });
}
const W = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), A = (t) => t.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (r, c, o) => o ? o.toUpperCase() : c.toLowerCase()
), h = (t) => {
  const r = A(t);
  return r.charAt(0).toUpperCase() + r.slice(1);
}, f = (...t) => t.filter((r, c, o) => !!r && r.trim() !== "" && o.indexOf(r) === c).join(" ").trim(), H = (t) => {
  for (const r in t)
    if (r.startsWith("aria-") || r === "role" || r === "title")
      return !0;
};
var z = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const V = u(
  ({
    color: t = "currentColor",
    size: r = 24,
    strokeWidth: c = 2,
    absoluteStrokeWidth: o,
    className: l = "",
    children: i,
    iconNode: k,
    ...d
  }, w) => a(
    "svg",
    {
      ref: w,
      ...z,
      width: r,
      height: r,
      stroke: t,
      strokeWidth: o ? Number(c) * 24 / Number(r) : c,
      className: f("lucide", l),
      ...!i && !H(d) && { "aria-hidden": "true" },
      ...d
    },
    [
      ...k.map(([v, x]) => a(v, x)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
const B = (t, r) => {
  const c = u(
    ({ className: o, ...l }, i) => a(V, {
      ref: i,
      iconNode: r,
      className: f(
        `lucide-${W(h(t))}`,
        `lucide-${t}`,
        o
      ),
      ...l
    })
  );
  return c.displayName = h(t), c;
};
const E = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], I = B("arrow-right", E);
function P(t) {
  return /* @__PURE__ */ n("div", { className: "flex h-full flex-col bg-white", children: [
    /* @__PURE__ */ e("div", { className: "grid h-full grid-cols-1 overflow-auto p-0 sm:p-8", children: /* @__PURE__ */ e(
      "div",
      {
        className: s(
          "flex h-full w-full items-center justify-center rounded-none sm:rounded-xl",
          t.center && "px-0 sm:px-60",
          t.className
        ),
        children: /* @__PURE__ */ n("div", { className: "w-full max-w-[460px] px-4 sm:px-4 lg:px-0", children: [
          /* @__PURE__ */ n(N, { className: s("mt-4 space-y-4 px-0"), children: [
            /* @__PURE__ */ e(p, { className: "mx-auto mb-4 w-40" }),
            /* @__PURE__ */ n("div", { className: "space-y-2", children: [
              /* @__PURE__ */ n("div", { className: "flex items-center justify-between", children: [
                /* @__PURE__ */ e(y, { className: "text-2xl font-bold", children: t.title }),
                t.onBack && /* @__PURE__ */ n(
                  "button",
                  {
                    type: "button",
                    onClick: t.onBack,
                    className: "flex cursor-pointer items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900",
                    children: [
                      /* @__PURE__ */ e(I, { className: "size-4" }),
                      t.backLabel ?? "رجوع"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ e("div", { className: "font-medium", children: t.subtitle })
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "mt-6", children: t.children })
        ] })
      }
    ) }),
    /* @__PURE__ */ e(m, {})
  ] });
}
function R() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M22.1667 4.84155H5.83333C4.54467 4.84155 3.5 5.88622 3.5 7.17489V23.5082C3.5 24.7969 4.54467 25.8416 5.83333 25.8416H22.1667C23.4553 25.8416 24.5 24.7969 24.5 23.5082V7.17489C24.5 5.88622 23.4553 4.84155 22.1667 4.84155Z",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M18.6666 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M3.5 11.8416H24.5",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M9.33337 2.50806V7.17472",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M19.8334 16.5081H12.8334",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M15.1666 21.1748H8.16663",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M8.16663 16.5081H8.17788",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M19.8334 21.1748H19.8446",
            stroke: "white",
            strokeWidth: 1.8,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
function S() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: 28,
      height: 29,
      viewBox: "0 0 28 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14 2.50806C16.2635 2.50764 18.4782 3.16568 20.3743 4.40197C22.2703 5.63826 23.7658 7.39941 24.6785 9.47077C25.5911 11.5421 25.8815 13.8342 25.5142 16.0677C25.1469 18.3012 24.1379 20.3797 22.61 22.0497",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M14 7.1748V14.1748L18.6667 16.5081",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M2.91671 10.5291C2.54495 11.6592 2.34823 12.8395 2.33337 14.0291",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M3.30176 18.8416C3.95684 20.3487 4.92294 21.7004 6.13676 22.8082",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M5.40869 6.2823C5.73424 5.92791 6.0814 5.59399 6.44819 5.28247",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M10.0847 25.1648C12.994 26.2012 16.1956 26.0418 18.9876 24.7214",
            stroke: "white",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}
export {
  P as AuthLayout,
  R as CalendarIcon,
  S as ClockHistoryIcon,
  m as Footer,
  O as Layout,
  p as Logo
};
//# sourceMappingURL=index.js.map
